import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Lazy from "yup/lib/Lazy";
import Spinner from "../app/Components/Shared/Spinner";

const Cuadrodemando = lazy(() => import("./page/Ideas/Index"));
const CreateIdeas = lazy(() => import("./page/Ideas/CreateIdea"));
const EditIdeas = lazy(() => import("./page/Ideas/EditarIdea"));
const ListaIdeas = lazy(() => import("./page/Ideas/ListIdea"));
const CatalogoPremios = lazy(() => import("./page/Ideas/Premios"));
const ListCategorias = lazy(() => import("./page/Ideas/CategoriaPremios"));
const CreateCategorias = lazy(() => import("./page/Ideas/CreateCategoria"));
const Evaluaciones = lazy(() => import("./page/Ideas/EvaluationList"));
const ComiteEvaluador = lazy(() => import("./page/Ideas/ListJurado"));
const ComiteEvaluadorUser = lazy(() => import("./page/Ideas/ListJuradoUser"));
const Revision = lazy(() => import("./page/Ideas/RevisionList"));
const DetalleIdeas = lazy(() => import("./page/Ideas/DetalleIdea"));
const EstadoIdeas = lazy(() => import("./page/Ideas/IdeasEstadoList"));
const MisIdeas = lazy(() => import("./page/Ideas/ListaMisIdeas"));
const Catalogo = lazy(() => import("./page/Ideas/CatalogoPremiosCard"));
const SolicitarPremiosAdmin = lazy(() =>
  import("./page/Ideas/SolicitudPremioAdmin")
);
const SolicitarPremiosPersona = lazy(() =>
  import("./page/Ideas/SolicitarPremioPersona")
);
const Interacciones = lazy(() => import("./page/Ideas/LinstaInteraccion"));
const Perfil = lazy(() => import("./page/user-pages/Perfil"));
const GraficoInteraccio = lazy(() => import("./page/Ideas/InteraccionGrafica"));
const ListaPersonasPuntos = lazy(() =>
  import("./page/Ideas/PersonaPuntosList")
);
const Premios = lazy(() => import("./page/Ideas/ListPremiosPersona"));
const CrearUsuario = lazy(() => import("./page/Ideas/CrearUsuario"));
const listaUsuarios = lazy(() => import("./page/Ideas/ListaUsuarios"));
const CreateIdeaAdmin = lazy(() => import("./page/Ideas/CreateIdeaAdmin"));
const IntenteacionMes = lazy(() => import("./page/Ideas/InteresacionMonth"));
const Organigrama = lazy(() => import("./page/Ideas/Organigrama"));
const ReportablidadInteraccion = lazy(() =>
  import("./page/Reportablidad/ReportablidadInteraccion")
);
const ReportablidadDimensiones = lazy(() =>
  import("./page/Reportablidad/ReportablidadDimensiones")
);
const ListModulos = lazy(() =>
  import("./page/Reportablidad/ListaInteracionReporte")
);
const ListIdeaPersonaPuntos = lazy(() =>
  import("./page/Ideas/ListIdeaPersonaPuntos")
);
const ListaDetallePersonaPuntosConsumidos = lazy(() =>
  import("./page/Ideas/ListaDetallePersonaPuntosConsumidos")
);
const GestionPlataforma = lazy(() => import("./page/Ideas/GestionPlataforma"));
const CrearDesafio = lazy(() => import("./page/desafios/CrearDesafio"));
const ListDesafios = lazy(() => import("./page/desafios/ListDesafios"));
const MisDesafios = lazy(() => import("./page/desafios/MisDesafios"));
const CrearDesafioAdmin = lazy(() => import("./page/desafios/CrearDesafioAdmin"));


const DetalleDesafio = lazy(() => import("./page/desafios/DetalleDesafio"));
const ListPaqueteCriterios = lazy(() =>
  import("./page/paqueteCriterios/ListPaqueteCriterios")
);
const CreatePaqueteCriterios = lazy(() =>
  import("./page/paqueteCriterios/CreateCriterio")
);

//rutas de momentos
const Momentos = lazy(() => import("./page/Momentos/Index"));
const CreateMomentos = lazy(() => import("./page/Momentos/Create"));

//rutas de Fortalenciendo Vinculos
const Suggestions = lazy(() => import("./page/suggestions/Index"));
const CreateSuggestion = lazy(() => import("./page/suggestions/Create"));

//rutas de Compromisos
const Compromisos = lazy(() => import("./page/compromisos/Index"));
const CompromisosPersonales = lazy(() =>
  import("./page/compromisos/CompromisosPersonales")
);
const CreateCompromiso = lazy(() => import("./page/compromisos/Create"));
const DashboardCompromisos = lazy(() => import("./page/compromisos/Dashboard"));
const ListCompromisos = lazy(() =>
  import("./page/compromisos/HistoricoCompromisos")
);
const DetalleCompromisos = lazy(() =>
  import("./page/compromisos/DetalleCompromiso")
);
const ListCompromisosArea = lazy(() =>
  import("./page/compromisos/HistoricoCompromisosArea")
);
const ListCompromisosGerencia = lazy(() =>
  import("./page/compromisos/HistoricoCompromisosGerencia")
);
const ListCompromisosTotales = lazy(() =>
  import("./page/compromisos/HistoricoCompromisosTotal")
);
const CompromisosCards = lazy(() =>
  import("./page/compromisos/CompromisosCards")
);
const CompromisosVerificacion = lazy(() =>
  import("./page/compromisos/VerificarCompromisos")
);

//Reportablidad
const RDashborard = lazy(() =>
  import("./page/Reportablidad/DashboardReportablidad")
);
const RDashborardArea = lazy(() =>
  import("./page/Reportablidad/ReportablidadArea")
);
const RDashborardListIdea = lazy(() =>
  import("./page/Reportablidad/ReportablidadListIdea")
);
const RDashboardGerencia = lazy(() =>
  import("./page/Reportablidad/ReportablidadGerencia")
);
const RDRatioParticipantes = lazy(() =>
  import("./page/Reportablidad/RatioParticipantes")
);


const ReportablidadDesafio = lazy(() =>
  import("./page/desafios/Reportabilidad/DashboardReportablidad.js")
); 

const ReportablidadDesafioDimensiones = lazy(() =>
  import("./page/desafios/Reportabilidad/ReportablidadDimensiones.js")
); 

 
const ReportablidadDesafioArea = lazy(() =>
  import("./page/desafios/Reportabilidad/ReportablidadArea.js")
); 


const ReportablidadDesafioGerencia = lazy(() =>
  import("./page/desafios/Reportabilidad/ReportablidadGerencia.js")
); 


const ReportablidadDesafioRatio = lazy(() =>
  import("./page/desafios/Reportabilidad/RatioParticipantes.js")
); 

 

//rutas de Rutinas
const Rutina = lazy(() => import("./page/rutina/Index"));
const CreateRutina = lazy(() => import("./page/rutina/Create"));
const ListIndicador = lazy(() => import("./page/rutina/ListIndicador"));
const DetalleRutina = lazy(() => import("./page/rutina/Detalle"));
const PlanAccionEstado = lazy(() => import("./page/rutina/ListEstado"));
const PlanAccionArea = lazy(() => import("./page/rutina/ListarPlanesArea"));

//const Error404 = lazy(() => import("./page/error-pages/Error404"));
const Error500 = lazy(() => import("./page/error-pages/Error500"));

const Login = lazy(() => import("./page/user-pages/Login"));
const Lockscreen = lazy(() => import("./page/user-pages/Lockscreen"));
const RecoveryPassword = lazy(() =>
  import("./page/user-pages/RecoveryPassword")
);

//Fortaleciendo Vinculos

class AppRoutes extends Component {
  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/cuadrodemando" component={Cuadrodemando} />
          <Route exact path="/ideas/create" component={CreateIdeas} />
          <Route exact path="/ideas/editar/:id" component={EditIdeas} />
          <Route exact path="/ideas/lista" component={ListaIdeas} />
          <Route exact path="/premios/catalogo" component={CatalogoPremios} />
          <Route exact path="/categorias/catalogo" component={ListCategorias} />
          <Route exact path="/create/categorias" component={CreateCategorias} />
          <Route exact path="/ideas/evaluaciones" component={Evaluaciones} />
          <Route
            exact
            path="/ideas/gestionPlataforma"
            component={GestionPlataforma}
          ></Route>
          {/* <Route exact path="/ideas/gestionPlataforma" component={GestionPlataforma}>
            <Route path="/ideas/gestionPlataforma/puestos" component={GestionPuestos} />
            <Route path="/ideas/gestionPlataforma/ubicacionProcesos" component={GestionUbicacionProceso} />
          </Route> */}
          <Route
            exact
            path="/ideass/comiteevaluador"
            component={ComiteEvaluador}
          />
          <Route
            exact
            path="/ideass/userevaluador"
            component={ComiteEvaluadorUser}
          />
          <Route exact path="/ideas/revision" component={Revision} />
          <Route exact path="/idea/detalle/:id" component={DetalleIdeas} />
          <Route exact path="/idea/estado/:id" component={EstadoIdeas} />
          <Route exact path="/idea/misideas" component={MisIdeas} />
          <Route exact path="/ideas/catalogo" component={Catalogo} />
          <Route
            exact
            path="/idea/listapremiosadmin"
            component={SolicitarPremiosAdmin}
          />
          <Route
            exact
            path="/idea/listapremiospersona"
            component={SolicitarPremiosPersona}
          />
          <Route exact path="/fortaleciendoVinculos" component={Suggestions} />
          <Route exact path="/Interacciones" component={Interacciones} />
          <Route exact path="/perfil" component={Perfil} />
          <Route
            exact
            path="/graficointeracion"
            component={GraficoInteraccio}
          />
          <Route exact path="/listaPersonas" component={ListaPersonasPuntos} />
          <Route exact path="/ideas/premiosPersonas/:id" component={Premios} />
          <Route exact path="/ideas/premiosPersonas" component={Premios} />
          <Route exact path="/ideas/crearUsuario" component={CrearUsuario} />
          <Route exact path="/ideas/listaUsuarios" component={listaUsuarios} />
          <Route
            exact
            path="/ideas/createIdeaAdmin"
            component={CreateIdeaAdmin}
          />
          <Route exact path="/interaccionMensual" component={IntenteacionMes} />
          <Route exact path="/organigrama" component={Organigrama} />
          <Route
            exact
            path="/ReportablidadInteracion"
            component={ReportablidadInteraccion}
          />
          <Route
            exact
            path="/ReportablidadDimensiones"
            component={ReportablidadDimensiones}
          />
          <Route
            exact
            path="/listaModulo/:m/fechaInicio/:fi/fechaFin/:ff"
            component={ListModulos}
          />
          <Route
            exact
            path="/ListIdeaPersonaPuntos/:id"
            component={ListIdeaPersonaPuntos}
          />
          <Route
            exact
            path="/ListIdeaPersonaPuntosConsumidos/:id"
            component={ListaDetallePersonaPuntosConsumidos}
          />

          <Route exact path="/desafio/create" component={CrearDesafio} />
          <Route exact path="/desafio/createAdmin" component={CrearDesafioAdmin} />

          <Route exact path="/MisDesafios/lista" component={MisDesafios} />
          <Route exact path="/desafios/lista" component={ListDesafios} />

          <Route exact path="/desafio/detalle/:id" component={DetalleDesafio} />

          <Route
            exact
            path="/paqueteCriterios/lista"
            component={ListPaqueteCriterios}
          />
          <Route
            exact
            path="/paqueteCriterios/crear"
            component={CreatePaqueteCriterios}
          />

          {/* Compromisos */}
          <Route exact path="/compromisos" component={Compromisos} />
          <Route
            exact
            path="/compromisosPersonales"
            component={CompromisosPersonales}
          />
          <Route exact path="/createCompromiso" component={CreateCompromiso} />
          <Route
            exact
            path="/compromisos/dashboard"
            component={DashboardCompromisos}
          />
          <Route
            exact
            path="/compromisos/historico"
            component={ListCompromisos}
          />
          <Route
            exact
            path="/compromisos/detalles/:id"
            component={DetalleCompromisos}
          />
          <Route
            exact
            path="/compromisos/historico/area"
            component={ListCompromisosArea}
          />
          <Route
            exact
            path="/compromisos/historico/gerencia"
            component={ListCompromisosGerencia}
          />
          <Route
            exact
            path="/compromisos/historico/total"
            component={ListCompromisosTotales}
          />
          <Route
            exact
            path="/compromisos/estados/:id"
            component={CompromisosCards}
          />
          <Route
            exact
            path="/compromisos/verificacion"
            component={CompromisosVerificacion}
          />
          <Route exact path="/Reportablidad" component={RDashborard} />
          <Route exact path="/ReportablidadArea" component={RDashborardArea} />
          <Route exact path="/Seguimiento" component={RDashborardListIdea} />
          <Route
            exact
            path="/ReportablidadGerencia"
            component={RDashboardGerencia}
          />
          <Route
            exact
            path="/ratioParticipantes"
            component={RDRatioParticipantes}
          />

<Route exact path="/Desafio/Reportablidad" component={ReportablidadDesafio} />

<Route exact path="/Desafio/ReportablidadDimensiones" component={ReportablidadDesafioDimensiones} />

<Route exact path="/Desafio/ReportablidadArea" component={ReportablidadDesafioArea} />
<Route exact path="/Desafio/ReportablidadGerencia" component={ReportablidadDesafioGerencia} />
<Route
            exact
            path="/Desafio/ratioParticipantes"
            component={ReportablidadDesafioRatio}
          />



          {/*Fin - Compromisos */}

          <Route exact path="/rutina" component={Rutina} />
          <Route
            exact
            path="/rutina/createindicador"
            component={CreateRutina}
          />
          <Route exact path="/rutina/listindicador" component={ListIndicador} />
          <Route exact path="/rutina/detalle/:id" component={DetalleRutina} />
          <Route
            exact
            path="/rutina/planaccion/:id"
            component={PlanAccionEstado}
          />
          <Route
            exact
            path="/rutina/planaccionarea"
            component={PlanAccionArea}
          />

          <Route exact path="/momentos" component={Momentos} />
          <Route exact path="/momentos/crear" component={CreateMomentos} />
          <Route
            exact
            path="/publicaciones/Create"
            component={CreateSuggestion}
          />
          <Redirect from="*" exact to="/cuadrodemando" />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;
